module.exports = __webpack_public_path__ + "r-v3/img/menu_translation_on.89c91e27.png";